// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"ConveniosPage_containerPrincipal__RWZlE"};